export const StepNumberEnum = {
    STEP1: 1,
    STEP2: 2,
    STEP3: 3,
    STEP4: 4,
} as const;

export type StepNumberType =
    (typeof StepNumberEnum)[keyof typeof StepNumberEnum];
